/**
 * Calculate the interpolated correction of a valve.
 * @param absenceTemperature The absence temperature.
 * @param confortTemperature The confort temperature.
 * @param temperature The temperature.
 * @param correction The correction.
 * @returns The interpolated correction.
 */
export const calculateInterpolatedCorrection = (
  absenceTemperature: number,
  confortTemperature: number,
  temperature: number,
  correction: number,
): number => {
  if (temperature < absenceTemperature || correction <= 0) return 0;
  else if (temperature > confortTemperature) return correction;
  else if (confortTemperature !== absenceTemperature) {
    const pourcentage = (temperature - absenceTemperature) / (confortTemperature - absenceTemperature);
    return correction * pourcentage;
  }
  return 0;
};
